import {createContext} from "react";

export default createContext<any>(null);

